import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocalStorage } from 'react-use';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import {
  Breadcrumb,
  Card,
  Col,
  Container,
  Row,
} from 'react-bootstrap';
import AuditorProofAnswerInput from '../Widget/Proof/Auditor/Input.js';
import AuditorProofAnswerFormula from '../Widget/Proof/Auditor/Formula.js';
import AuditorProofAnswerTable from '../Widget/Proof/Auditor/Table.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import FormRepository from 'repository/Form.js';

export default function Auditor() {
  const history = useHistory();
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);
  const { formId } = useParams();

  const [schedule, setSchedule] = useState();
  const [criteria, setCriteria] = useState();
  const [answers, setAnswers] = useState([]);
  const [scores, setScores] = useState([]);

  const repository = new FormRepository(auth.token);

  const location = useLocation();

  const handleClickAudit = async (e) => {
    e.preventDefault();
    const myArray = location.pathname.split("/");
    if(myArray[1] == 'admin'){
      return history.push(`/admin/schedules`);
    }else{
      return history.push(`/auditor/${auth.employee.EMP_ID}/audits`);
    }
  }

  const handleClickDepartment = async (e) => {
    e.preventDefault();
    const myArray = location.pathname.split("/");
    if(myArray[1] == 'admin'){
      return history.push(`/admin/audits/${schedule.SCHEDULE_ID}/proofs`);
    }else{
      return history.push(`/auditor/${auth.employee.EMP_ID}/audits/${schedule.SCHEDULE_ID}/evaluations`);
    }
  }

  const fetchForm = async () => {

    try {

      const response = await repository.fetch(formId);

      //check status to readonly mode
      if (response.data.SUBMIT_AT !== null) {
        setReadonly(true);
      }

      setSchedule(response.data.schedule);
      setCriteria(response.data.criteria);
      //setAnswers(response.data.answers.sort((a, b) => natsort(a.question.QUESTION_CODE, b.question.QUESTION_CODE)));
      setAnswers(response.data.answers
        .sort((p, n) => p.question.QUESTION_CODE > n.question.QUESTION_CODE
        ? 1
        : (p.question.QUESTION_CODE
          ? -1
          : 0
        )
      ));
      setScores(response.data.schedule.instrument.score.scoreIndices);


    } catch (error) {
      setSwal(error);
      console.log(error);
    }
  }

  useEffect(() => {
    fetchForm();
  }, []);

  return (
    <Container fluid>
      {swal}
      <Breadcrumb>
        <Breadcrumb.Item onClick={handleClickAudit}>
          Audit
        </Breadcrumb.Item>
        <Breadcrumb.Item onClick={handleClickDepartment}>
          { schedule && schedule.auditee.department.DEPT_NAME}
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Proof Submission
        </Breadcrumb.Item>
      </Breadcrumb>
      {criteria && (
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title style={{fontWeight:'bold'}} as="h3">{criteria.CRITERIA_CODE}. {criteria.CRITERIA_LABEL}</Card.Title>
              </Card.Header>
              <Card.Body>
                <div style={{whiteSpace: 'pre-wrap', fontSize:'17px'}} dangerouslySetInnerHTML={{__html: criteria.CRITERIA_DESCRIPTION}} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {answers && answers.map((answer, key) => {
        switch (answer.question.QUESTION_TYPE_ID) {
          case 1:
            return <AuditorProofAnswerInput key={key} answer={answer} />;
          case 2:
            return <AuditorProofAnswerFormula key={key} answer={answer} />;
          case 3:
            return <AuditorProofAnswerTable key={key} scores={scores} answer={answer} />;
        }
      })}
    </Container>
  );
}